@if (countriesQueryResults$ | async; as result) {
<kendo-label text="Country">
    <kendo-multiselect [data]="result.data ?? []"
                       [disabled]="isDisabled || result.isLoading"
                       [loading]="result.isLoading"
                       [placeholder]="result.isLoading ? 'Loading' : ''"
                       [virtual]="virtual"
                       [value]="value"
                       (valueChange)="handleValueChange($event)"
                       (blur)="handleBlur()"
                       textField="name"
                       valueField="code"
                       [valuePrimitive]="true">
    </kendo-multiselect>
</kendo-label>
}
